import React, { useCallback, useMemo, useState } from 'react';

import EventNoteIcon from '@mui/icons-material/EventNote';
import GroupsIcon from '@mui/icons-material/Groups';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import PropTypes from 'prop-types';

import { 
  DashboardIcon,
  UserIcon,
  UserListIcon,
  UsersIcon,
} from '@src/components/icons';

const SidebarContext = React.createContext(null);

const top = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    to: '/dashboard',
    icon: <DashboardIcon />,
  },
  {
    key: 'admin',
    label: 'Admin',
    to: '/admin',
    icon: <UserIcon />,
  },
  {
    key: 'users',
    label: 'Users',
    to: '/users',
    icon: <UsersIcon />,
  },
  {
    key: 'schedule',
    label: 'Schedule',
    to: '/schedule',
    icon: <EventNoteIcon />,
  },
  {
    key: 'jobs',
    label: 'Jobs',
    to: '/jobs',
    icon: <UserListIcon />,
  },
  {
    key: 'clients',
    label: 'Clients',
    to: '/clients',
    icon: <PeopleAltIcon />,
  },
  {
    key: 'team',
    label: 'Team',
    to: '/team',
    icon: <GroupsIcon />,
  },
];

const bottom = [
  {
    key: 'settings',
    label: 'Settings',
    to: '/settings',
    icon: <SettingsIcon />,
  },
  {
    key: 'logout',
    label: 'Logout',
    to: '/auth/logout',
    icon: <LogoutOutlinedIcon />,
  },
];


function SidebarProvider({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const open = useCallback(() => {
    setIsCollapsed(false);
  }, []);

  const collapse = useCallback(() => {
    setIsCollapsed(true);
  }, []);

  const toggle = useCallback(() => {
    setIsCollapsed((prevValue) => !prevValue);
  }, []);

  const contextValue = useMemo(() => ({
    isCollapsed,
    open,
    collapse,
    toggle,
    items: {
      top,
      bottom,
    },
  }), [collapse, isCollapsed, open, toggle]);

  return <SidebarContext.Provider value={contextValue}>{children}</SidebarContext.Provider>;
}

SidebarProvider.displayName = 'SidebarProvider';
SidebarProvider.propTypes = {
  children: PropTypes.node,
};
export { SidebarContext, SidebarProvider };
